import { MEASURE_TRANSACTION, MeasureUnion } from '@shared/types';
import { find, get, head, sortBy, toLower } from 'lodash';

export const getDefaultMeasure = (
  measures: Partial<MeasureUnion>[],
  measureTransaction: MEASURE_TRANSACTION,
): Partial<MeasureUnion> | null => {
  const sortedMeasures = sortBy(measures, (m) => toLower(m.description));
  const condition =
    measureTransaction === MEASURE_TRANSACTION.Order
      ? 'is_default'
      : `default_unit.${measureTransaction}`;
  const defaultMeasure = find(sortedMeasures, condition);

  return defaultMeasure || head(sortedMeasures);
};

export const isDefaultMeasure = (
  measure,
  measureTransaction: MEASURE_TRANSACTION,
): boolean => {
  const condition =
    measureTransaction === MEASURE_TRANSACTION.Order
      ? 'is_default'
      : `default_unit.${measureTransaction}`;

  return get(measure, condition, false);
};
